import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateTheCampaignSchedule } from './../../store/ReportDetails/actionCreator'
import {
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@material-ui/core'
import EventIcon from '@material-ui/icons/Event'
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/moment'
import {
  DateRange,
  AccessTime,
  ArrowBack,
  ArrowForward,
} from '@material-ui/icons'
import SaveIcon from '@material-ui/icons/Save'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment-timezone'
import { shape, string, object, number, bool } from 'prop-types'
import { displayReadableTime } from '../../services/displayReadableTime'

const styles = makeStyles((theme) => ({
  cardDiv: {
    width: '33%',
    padding: '2px',
    display: 'inline-block',
    verticalAlign: 'top',
    textAlign: 'left',
  },
  centerListSmall: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
    maxWidth: '50%',
    minWidth: '300px',
  },
  iconDelete: {
    fontSize: 24,
    padding: '1px',
    margin: '1px',
    textAlign: 'right',
  },
  iconStyle: {
    width: '36px',
    height: '36px',
  },
  messageFont: {
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    margin: 0,
    whiteSpace: 'normal',
  },
}))

const enablePicker = (time, timezone) => {
  var enable = false
  const now = new Date(changeTimezone(new Date(), timezone))
  now.setHours(now.getHours(), now.getMinutes() + 1, 0, 0)
  var newDate = new Date(time)
  if (now < newDate) {
    enable = true
  }
  return enable
}

const enableSaveButton = (time, newTime) => {
  var enable = false
  var scheduledTime = new Date(time).toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  })
  var newScheduledTime = new Date(newTime).toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  })
  if (scheduledTime !== newScheduledTime) {
    enable = true
  }
  return enable
}

const displayWorkerTypes = (displayWorkerTypes) => {
  return displayWorkerTypes.split(',').join(', ')
}

const displayDelay = (displayData) => {
  var displayDataMinutes = '2 Minutes'
  if (displayData) {
    displayDataMinutes = '15 Minutes'
  }
  return displayDataMinutes
}

const messageSummaryData = (
  classes,
  contact_priority,
  messageTitle,
  messagePhone,
  messageSms,
  messageEmail,
  messageResponsePositive,
  messageResponseNegative,
  messageResponsePositiveEs,
  messageResponseNegativeEs,
) => {
  let returnVar = {}
  if (messageResponsePositive) {
    messageResponsePositive =
      messageResponsePositive + ' https://r.tgt.com/12345'
  }
  if (messageResponseNegative) {
    messageResponseNegative =
      messageResponseNegative + ' https://r.tgt.com/abcde'
  }
  if (messageResponsePositiveEs) {
    messageResponsePositiveEs =
      messageResponsePositiveEs + ' https://r.tgt.com/12345'
  }
  if (messageResponseNegativeEs) {
    messageResponseNegativeEs =
      messageResponseNegativeEs + ' https://r.tgt.com/abcde'
  }
  for (let i = 0; i < contact_priority.length; i++) {
    if (contact_priority.charAt(i) === 'p') {
      let temp = (
        <Paper key={0} className={classes.cardDiv} elevation={1}>
          <Typography component="span" variant="body2">
            Phone Message Preview
          </Typography>
          <Typography component="span" variant="body1">
            <pre className={classes.messageFont}>{messagePhone}</pre>
            <br />
            {messageResponsePositive}
            <br />
            {messageResponseNegative}
          </Typography>
        </Paper>
      )
      returnVar[i] = temp
    } else if (contact_priority.charAt(i) === 's') {
      let temp = (
        <Paper key={1} className={classes.cardDiv} elevation={1}>
          <Typography component="span" variant="body2">
            SMS Message Preview
          </Typography>
          <Typography component="span" variant="body1">
            <pre className={classes.messageFont}>{messageSms}</pre>
            <br />
            {messageResponsePositive}
            <br />
            {messageResponseNegative}
          </Typography>
        </Paper>
      )
      returnVar[i] = temp
    } else if (contact_priority.charAt(i) === 'e') {
      let temp = (
        <Paper key={2} className={classes.cardDiv} elevation={1}>
          <Typography component="span" variant="body2">
            Email Message Preview
          </Typography>
          <Typography component="span" variant="body1">
            <br />
            SUBJECT: {messageTitle}
            <br />
            <pre className={classes.messageFont}>{messageEmail}</pre>
            <br />
            {messageResponsePositive}
            <br />
            {messageResponseNegative}
            <br />
            {messageResponsePositiveEs}
            <br />
            {messageResponseNegativeEs}
          </Typography>
        </Paper>
      )
      returnVar[i] = temp
    }
  }
  if (contact_priority.length <= 3 && contact_priority.length > 0) {
    return [0, 1, 2].map(function (n) {
      return returnVar[n]
    })
  }
  return ''
}

const changeTimezone = (newScheduleData, timezoneData) => {
  if (timezoneData === '') return newScheduleData
  return new Date(newScheduleData).toLocaleString('en-US', {
    timeZone: timezoneData,
  })
}

const CampaignSummaryItem = (props) => {
  const classes = styles(props)
  const {
    timezoneDataFromParent,
    dbScheduleDataFromParent,
    blossomIDFromParent,
    jobIDFromParent,
    campaign_summary,
  } = props

  const [timezoneData, setTimezoneData] = useState(timezoneDataFromParent)

  const [dbScheduleData, setDbScheduleData] = useState(
    changeTimezone(dbScheduleDataFromParent, timezoneDataFromParent),
  )
  const [newScheduleData, setNewScheduleData] = useState(
    changeTimezone(dbScheduleDataFromParent, timezoneDataFromParent),
  )
  const dispatch = useDispatch()

  useEffect(() => {
    if (!dbScheduleData || timezoneData !== timezoneDataFromParent) {
      setDbScheduleData(
        changeTimezone(dbScheduleDataFromParent, timezoneDataFromParent),
      )
    }
    if (!newScheduleData || timezoneData !== timezoneDataFromParent) {
      setNewScheduleData(
        changeTimezone(dbScheduleDataFromParent, timezoneDataFromParent),
      )
    }
    if (!timezoneData || timezoneData !== timezoneDataFromParent) {
      setTimezoneData(timezoneDataFromParent)
    }
  }, [
    dbScheduleData,
    newScheduleData,
    timezoneData,
    dbScheduleDataFromParent,
    timezoneDataFromParent,
  ])

  let keyCounter = -1

  const getCurrentKey = (updateCounter) => {
    if (updateCounter) keyCounter += 1
    return keyCounter
  }

  const editCampaignStatus = (action, props) => {
    dispatch(
      updateTheCampaignSchedule(
        blossomIDFromParent,
        jobIDFromParent,
        moment.tz(
          moment(newScheduleData).format('YYYY-MM-DD HH:mm:SS'),
          timezoneData,
        ),
      ),
    )
      .then(() => {
        // Update state when only successful
        setDbScheduleData(newScheduleData)
      })
      .catch(() => {
        // Do something
      })
  }

  const handleDateChange = (date) => {
    setNewScheduleData(date)
  }

  let pickerButton = ''
  if (!enablePicker(dbScheduleData, timezoneData)) {
    pickerButton = (
      <ListItemText
        key={getCurrentKey(false) + '-0'}
        primary="Message Schedule"
        secondary={displayReadableTime(
          campaign_summary['schedule'],
          timezoneData,
        )}
      />
    )
  } else {
    pickerButton = (
      <ListItemText
        key={getCurrentKey(false) + '-1'}
        primary="Pick New Time to Send Notification"
        secondary={
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DateTimePicker
              style={{ width: 300 }}
              value={newScheduleData}
              onChange={handleDateChange}
              disablePast
              showTodayButton
              dateRangeIcon={<DateRange />}
              timeIcon={<AccessTime />}
              leftArrowIcon={<ArrowBack />}
              rightArrowIcon={<ArrowForward />}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      <EventIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </MuiPickersUtilsProvider>
        }
      />
    )
  }

  let saveButton = ''

  if (enableSaveButton(dbScheduleData, newScheduleData)) {
    saveButton = (
      <IconButton
        onClick={() => {
          editCampaignStatus('edit', props)
        }}
        aria-label="Update"
        className={classes.iconStyle}
      >
        <SaveIcon className={classes.iconDelete} />
      </IconButton>
    )
  }

  const displaySelectionList = (selection_list) => {
    return selection_list.map(function (name, index) {
      return (
        <span key={getCurrentKey(false) + String(index) + '-2'}>
          {' '}
          {name} <br />{' '}
        </span>
      )
    })
  }

  let contactByProximity = ''
  if (campaign_summary['contact_distance'] > 0) {
    contactByProximity = (
      <>
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Contact nearby team members distance"
            secondary={campaign_summary['contact_distance']}
          />
        </ListItem>
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Contact nearby team member types"
            secondary={displayWorkerTypes(
              campaign_summary['contact_distance_worker_types'],
            )}
          />
        </ListItem>
      </>
    )
  }

  return (
    <>
      <Typography variant="h6">Campaign Summary Data</Typography>
      {messageSummaryData(
        classes,
        campaign_summary['contact_priority'],
        campaign_summary['message_title'],
        campaign_summary['message_phone'],
        campaign_summary['message_sms'],
        campaign_summary['message_email'],
        campaign_summary['message_response_positive'],
        campaign_summary['message_response_negative'],
        campaign_summary['message_response_positive_es'],
        campaign_summary['message_response_negative_es'],
      )}
      <List key={getCurrentKey(true)} className={classes.centerListSmall}>
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Contacts Selected"
            secondary={displaySelectionList(campaign_summary['selection_list'])}
          />
        </ListItem>
        {contactByProximity}
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Delay After SMS and Email"
            secondary={displayDelay(campaign_summary['contactdelay'])}
          />
        </ListItem>
        <ListItem key={getCurrentKey(true)} divider>
          {pickerButton}
          {saveButton}
        </ListItem>
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Contact Start Time"
            secondary={displayReadableTime(
              campaign_summary['contactstart'],
              timezoneData,
            )}
          />
        </ListItem>
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Contact Stop Time"
            secondary={displayReadableTime(
              campaign_summary['contactstop'],
              timezoneData,
            )}
          />
        </ListItem>
        <ListItem key={getCurrentKey(true)} divider>
          <ListItemText
            key={getCurrentKey(false) + '-0'}
            primary="Campaign Completed Time"
            secondary={displayReadableTime(
              campaign_summary['campaignstop'],
              timezoneData,
            )}
          />
        </ListItem>
      </List>
    </>
  )
}

export default CampaignSummaryItem

CampaignSummaryItem.propTypes = {
  timezoneDataFromParent: string.isRequired,
  dbScheduleDataFromParent: object.isRequired,
  blossomIDFromParent: string.isRequired,
  jobIDFromParent: string.isRequired,
  campaign_summary: shape({
    schedule: string,
    message_sms: string,
    contactdelay: bool,
    message_email: string,
    message_title: string,
    nessage_phone: string,
    contact_distance: number,
    contact_priority: string,
    message_response_negative: string,
    message_response_positive: string,
    message_response_negative_es: string,
    message_response_positive_es: string,
    contact_distance_worker_types: string,
  }),
}
